module.exports = __webpack_public_path__ + "fulika/static/media/bg_feedback.98ddea9c.png";